(() => {
  if (window.lt3dWarrantyInstalled) return;
  window.lt3dWarrantyInstalled = true;
  const tracked = new Map();
  const update = () => document.documentElement.classList.toggle('lt3d-legal-in-view', [...tracked.values()].some(Boolean));
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => tracked.set(entry.target, entry.isIntersecting));
    update();
  }, {rootMargin:'24px 0px',threshold:0});
  const scan = () => {
    for (const el of tracked.keys()) if (!el.isConnected) { observer.unobserve(el); tracked.delete(el); }
    document.querySelectorAll('.lt3d-warranty,.cart__actions:has(.cart__checkout)').forEach(el => {
      if (!tracked.has(el)) { tracked.set(el,false); observer.observe(el); }
    });
    update();
  };
  scan();
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending=false;scan(); });
  }).observe(document.body,{childList:true,subtree:true});
})();
